import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { tokenSelector } from '../store/auth.selectors';
import { map } from 'rxjs/operators';
import { RoutesHelper } from '../../core/helpers/routes.helper';
import { AuthRoutes, getAuthRoute } from '../routes/auth.routes';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  private readonly store = inject<Store<AppState>>(Store);
  private readonly router = inject(Router);

  canActivate(
    route: AngularActivatedRoute
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.store.pipe(
      select(tokenSelector),
      map(token => {
        if (!token) {
          const url = route?._routerState?.url ?? '/core/home/';
          const queryParams = RoutesHelper.getParams(false);
          const resolvedBrandCode = RoutesHelper.resolveBrandCodeFromUrl();
          if (resolvedBrandCode && !queryParams.brandCode) {
            queryParams.brandCode = resolvedBrandCode;
          }

          this.router.navigate([getAuthRoute(AuthRoutes.authorize)], {
            queryParams: { ...queryParams, origin: url },
          });
          return false;
        }
        return true;
      })
    );
  }
}

interface AngularActivatedRoute extends ActivatedRouteSnapshot {
  _routerState: {
    url: string;
  };
}
